import { css } from 'styled-components'

export const AspiraStack = css`
  font-family: 'Aspira Webfont', Aspira, Helvetica, Arimo, 'Liberation Sans', Arial,
    sans-serif;
`

export const TimesNewRomanStack = css`
  font-family: 'Times New Roman', Tinos, 'Liberation Serif', serif;
`
